import { supabase } from "@/integrations/supabase/client";
import { NavigateFunction } from "react-router-dom";

const verifyUserRole = async (navigate: NavigateFunction) => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    
    if (error) {
      console.error("Error retrieving session:", error);
      navigate('/auth');
      return false;
    }
    
    if (!session || !session.user) {
      console.error("No active session found");
      navigate('/auth');
      return false;
    }
    
    // Check if user has a role in user_roles table
    const { data: roleData, error: roleError } = await supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', session.user.id)
      .maybeSingle();

    if (roleError) {
      console.error("Error checking user role:", roleError);
      navigate('/auth');
      return false;
    }

    // Allow access if user has either client or therapist role
    return roleData?.role === 'client' || roleData?.role === 'therapist';
  } catch (error) {
    console.error("Error verifying user role:", error);
    navigate('/auth');
    return false;
  }
};

const performSilentLogout = async () => {
  try {
    await supabase.auth.signOut();
    
    // Clear user data from localStorage
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userName');
    localStorage.removeItem('userId');
    localStorage.removeItem('clientsInfo');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('redirectAfterLogin');
    
    return true;
  } catch (error) {
    console.error("Error during silent logout:", error);
    return false;
  }
};

export const sessionManager = {
  verifyUserRole,
  performSilentLogout
};
